import {
  ACKNOWLEDGE_SCANNER_DISCONNECT,
  SCANNER_UNEXPECTEDLY_DISCONNECTED,
  START_REALTIME_SCAN_WATCHDOG,
  STOP_REALTIME_SCAN_WATCHDOG,
} from "constants/actionTypes";

export interface AcknowledgeScannerDisconnectAction {
  type: typeof ACKNOWLEDGE_SCANNER_DISCONNECT;
}

export interface ScannerUnexpectedDisconnectAction {
  type: typeof SCANNER_UNEXPECTEDLY_DISCONNECTED;
}

export interface StartRealtimeScanningWatchdogAction {
  type: typeof START_REALTIME_SCAN_WATCHDOG;
}

export interface StopRealtimeScanningWatchdogAction {
  type: typeof STOP_REALTIME_SCAN_WATCHDOG;
}

export const acknowledgeScannerDisconnect =
  (): AcknowledgeScannerDisconnectAction => ({
    type: ACKNOWLEDGE_SCANNER_DISCONNECT,
  });

export const scannerUnexpectedlyDisconnected =
  (): ScannerUnexpectedDisconnectAction => ({
    type: SCANNER_UNEXPECTEDLY_DISCONNECTED,
  });

export const startRealtimeScanningWatchdog =
  (): StartRealtimeScanningWatchdogAction => ({
    type: START_REALTIME_SCAN_WATCHDOG,
  });

export const stopRealtimeScanningWatchdog =
  (): StopRealtimeScanningWatchdogAction => ({
    type: STOP_REALTIME_SCAN_WATCHDOG,
  });
